import { Box, TextField, Autocomplete } from '@mui/material';
import theme from '../../theme';
import { Search, Close } from '@mui/icons-material';

const SearchBar = ({ searchValue, setSearchValue, handleSearch }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  return (
    <Box
      sx={{
        width: { xs: '100%', md: '510px' },
        height: '43px',
        display: 'flex',
        alignItems: 'center',
        gap: 3,
        p: 1.5,
        backgroundColor: theme.palette.surface.main,
        border: `1px solid ${theme.palette.grey.line}`,
        borderRadius: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1 }}>
        <Search sx={{ width: 16, height: 16, color: theme.palette.black[1] }} />
        <Autocomplete
          freeSolo
          options={[]}
          sx={{ flex: 1 }}
          inputValue={searchValue}
          onInputChange={(_, newInputValue) => {
            setSearchValue(newInputValue);
          }}
          onSubmit={handleSearch}
          renderInput={(params) => (
            <TextField
              {...params}
              autoFocus
              placeholder="앨범, 아티스트 등 검색"
              variant="standard"
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                sx: {
                  fontSize: '16px',
                  color: theme.palette.black[8],
                },
                onKeyPress: handleKeyPress,
              }}
            />
          )}
          clearIcon={
            <Close
              sx={{
                width: 16,
                height: 16,
                padding: '2px',
                backgroundColor: theme.palette.black[1],
                borderRadius: '50px',
                color: theme.palette.common.white,
              }}
            />
          }
        />
      </Box>
    </Box>
  );
};

export default SearchBar;
